/**
 * Documenti legali: identificativi, indirizzi e **versione accettata**.
 *
 * Il testo dei documenti non sta qui: vive nel sito di copertina
 * (`apps/landing/src/content/legal-content.ts`), che è l'applicativo che li
 * pubblica. Qui sta ciò che deve essere identico in tre punti diversi del
 * sistema — il modulo di registrazione che chiede il consenso, l'API che lo
 * registra, la pagina che mostra il documento — perché una versione diversa fra
 * client e server produrrebbe un consenso archiviato su un testo che nessuno ha
 * mai letto.
 */

/**
 * Versione dei documenti in vigore, in forma di data (ISO-8601).
 *
 * È il valore archiviato con ogni consenso: sapere *che cosa* è stato accettato
 * è l'unica parte del consenso che ha valore in caso di contestazione. Va
 * alzata **ogni volta** che cambia la sostanza di Termini o Informativa — un
 * test della copertina fallisce se il testo cambia senza che accada.
 */
export const LEGAL_VERSION = '2026-08-13';

/** Percorsi dei documenti sul sito di copertina. */
export const LEGAL_DOCUMENT_PATHS = {
  terms: '/termini',
  privacy: '/privacy',
  cookies: '/cookie',
} as const;

export type LegalDocumentId = keyof typeof LEGAL_DOCUMENT_PATHS;

export const LEGAL_DOCUMENT_IDS: readonly LegalDocumentId[] = Object.keys(
  LEGAL_DOCUMENT_PATHS,
) as LegalDocumentId[];

/**
 * Indirizzo assoluto di un documento.
 *
 * Serve nel client e nel corpo delle email, cioè in due posti che non stanno
 * sull'origine della copertina: un percorso relativo lì non porta da nessuna
 * parte. La barra finale della base viene tolta, così `https://falasta.it/` e
 * `https://falasta.it` producono lo stesso indirizzo.
 */
export function legalDocumentUrl(baseUrl: string, id: LegalDocumentId): string {
  return `${baseUrl.replace(/\/+$/, '')}${LEGAL_DOCUMENT_PATHS[id]}`;
}
